import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { n as i } from "../internals/not-a-regexp.js";
import { r as n } from "../internals/require-object-coercible.js";
import { t as o } from "../internals/to-string.js";
import { c as e } from "../internals/correct-is-regexp-logic.js";
var s = t("".indexOf);
r({
  target: "String",
  proto: !0,
  forced: !e("includes")
}, {
  includes: function includes(r) {
    return !!~s(o(n(this)), o(i(r)), arguments.length > 1 ? arguments[1] : void 0);
  }
});